module.exports = __webpack_public_path__ + "img/direction-3@2x.0a4cb906.png";